<template>
  <Loading v-if="isLoading"/>
  <template v-else>
    <Success v-if="reslut === 'success'" :first_sacn_time="first_sacn_time" :search_count="search_count"/>
  <Error v-else :message="msg" />
  </template>
  
</template>
<script lang="js" setup>
import { ref ,onMounted} from "vue";
import http from "@/api"
import Success from "./views/success.vue";
import Error from "./views/error.vue";
import Loading from "./views/loading.vue";
const baseData = ref({
    enterprise_name_en:'',
    enterprise_name: '',
    enterprise_logo: '',
    bg_pic: '',
    medias: [],//轮播图
    enterprise_slogan: '',//公司广告语
  })
  const resType = ref({
    message: '',
    time: '',
    times: '',
    type: ""
  })
  // 立即执行函数表达式 (IIFE)，确保代码在全局作用域中独立运行

  // 这个函数用于计算并设置 <html> 的 font-size
  function calcFontSize() {
    // 获取当前设备宽度
    const deviceWidth = document.documentElement.clientWidth;
    
    // 根据设计稿的宽度比例计算出合适的 font-size
    const baseFontSize = 75; // 基于750px设计稿的基准值
    const designWidth = 750; // 设计稿的宽度
    
    // 设置 <html> 的 font-size，确保页面内容按比例缩放
    document.documentElement.style.fontSize = `${baseFontSize * (deviceWidth / designWidth)}px`;
    
    console.log(`Device width: ${deviceWidth}px, Setting html font-size to: ${document.documentElement.style.fontSize}`);
  }
  
  calcFontSize();
  
  // 当窗口大小变化时，再次调用 calcFontSize 函数以更新 <html> 的 font-size
  window.addEventListener('resize', calcFontSize);

const isLoading = ref(true)
const loading = ref(false)
const template = ref('')
function GetUrlParam(paraName) {
  const url = document.location.href;

  const directQuery = new URL(url).searchParams.get(paraName);
  if (directQuery) {
    return directQuery;
  }

  const hashIndex = url.indexOf("#");
  if (hashIndex > -1) {
    const hashPart = url.slice(hashIndex + 1);
    const hashQueryIndex = hashPart.indexOf("?");
    if (hashQueryIndex > -1) {
      const hashQuery = hashPart.slice(hashQueryIndex + 1);
      const valueFromHash = new URLSearchParams(hashQuery).get(paraName);
      if (valueFromHash) {
        return valueFromHash;
      }
    }
  }

  return "";
}
const inputValue = ref('')
const domain_info = ref({})
const batch_info = ref({})
const search_count = ref('')
const first_sacn_time = ref('')
const reslut = ref('')
const msg = ref('')
const search = () => {
  if (!inputValue.value) {
    ElMessageBox.confirm("请输入防伪码", "提示", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
    isLoading.value = false
    return
  }
  loading.value = true
  http.get(`/qrcode_search/${inputValue.value}`).then((res) => {
    first_sacn_time.value = res.data.first_sacn_time;
    search_count.value =res.data.search_count
    reslut.value = res.data.status
    msg.value = res.data.msg;
  }).finally(() => {
    isLoading.value = false
    loading.value = false
  })
}
const getDetail = (code) => {
   http.get(`/enterprise_search/?code=${code}`).then(res=>{
     // console.log("res",res)
     template.value = res.data.template
     baseData.value = res?.data || {}
   }).catch(()=>{
   
   }).finally(()=>{
    isLoading.value = false
   })
 }
 const code = ref('')
onMounted(() => {
  // code.value = GetUrlParam("code") || ''
  // if(code.value == 'QYKJ'){
  //    document.title='微原防伪溯源系统'
  // }
  inputValue.value = GetUrlParam("qid") || ''
  if( inputValue.value){
    search()
  }
  // }else if(GetUrlParam('code')){
  //   getDetail(GetUrlParam('code'))
  // }else{
  //   // template.value = 'template4'
  //   template.value = 'template_common1'
  //   // console.log(" isLoading.value", isLoading.value)
  //   isLoading.value = false
  //   // console.log(" isLoading.value", isLoading.value)
  // }
})
</script>
<style lang="scss">
html,
body,
p {
  margin: 0px;
  padding: 0px;
 
  
}
html{
  color: #333333;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  font-variant: tabular-nums;
  line-height: 1.5;
  // background-color: #f3f3f3;
  font-feature-settings: 'tnum';
}
.item-block .item-row .labal img {
    width: .4rem;
}
.item-block .item-row .labal a {
    color: #3ea6ff;
}
</style>
